import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";
import { resolveNavigation, isMaintenancePath } from "./navigationGuard";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

// Returns "/maintenance" when the visitor must be bounced to the maintenance
// screen, or null to fall through. A throw from checkMaintenanceStatus (network
// blip) falls through silently, exactly as before.
async function maintenanceRedirect() {
  try {
    await store.dispatch("Auth/checkMaintenanceStatus");
    if (!store.getters["Auth/isMaintenanceActive"]) {
      return null;
    }
    if (store.getters["Auth/getMaintenanceKey"]) {
      // has key → fall through; backend validates on login
      return null;
    }
    return "/maintenance";
  } catch {
    return null;
  }
}

router.beforeEach(async (to, from, next) => {
  // Always allow the maintenance routes
  if (isMaintenancePath(to.path)) {
    return next();
  }
  const redirect = await maintenanceRedirect();
  if (redirect) {
    return next(redirect);
  }
  // Synchronous RBAC decision lives in ./navigationGuard (dependency-free).
  const target = resolveNavigation(to, store.getters);
  return target === undefined ? next() : next(target);
});

export default router;
